import { ticketApi } from '../api/ticket.api';

export const TICKET_AI_SUBMIT_MESSAGE = 'بررسی تیکت توسط هوش مصنوعی و ارسال آن به بخش مربوطه';

/** Must match ticketing.QueryFunctions.TICKET_TITLE_MAX_LEN */
export const TICKET_TITLE_MAX_LEN = 120;

export function clampTicketTitle(title) {
  const t = String(title || '').replace(/\s+/g, ' ').trim();
  if (!t) return 'بدون عنوان';
  if (t.length <= TICKET_TITLE_MAX_LEN) return t;
  return `${t.slice(0, TICKET_TITLE_MAX_LEN - 1).trim()}…`;
}

export function fallbackTicketTitle(text) {
  const words = (text || '').trim().split(/\s+/).filter(Boolean);
  if (!words.length) return 'بدون عنوان';
  return clampTicketTitle(words.slice(0, 10).join(' '));
}

/** First few words of the ticket body, for employee/dispatcher list rows. */
export function previewTicketWords(text, maxWords = 8) {
  const words = String(text || '').replace(/\s+/g, ' ').trim().split(' ').filter(Boolean);
  if (!words.length) return '';
  const sliced = words.slice(0, maxWords).join(' ');
  return words.length > maxWords ? `${sliced} …` : sliced;
}

export function ticketBodyPreview(ticket, maxWords = 8) {
  if (!ticket) return '';
  return previewTicketWords(
    ticket.ticket_text || ticket.description || ticket.text || '',
    maxWords,
  );
}

/** Resolve title via Django proxy to ai_server /ticket_summary; fallback only if AI truly fails. */
export async function resolveTicketTitle(text, ticketId) {
  try {
    const res = await ticketApi.getTicketAiSummary({
      text,
      ...(ticketId != null ? { ticket_id: ticketId } : {}),
    });
    const title = clampTicketTitle((res.data?.title || '').trim());
    if (res.data?.ai_generated && title) return title;
    if (title && !res.data?.ai_generated) {
      console.warn('[ticket_title] AI summary unavailable, using fallback:', res.data?.error);
    }
    if (title) return title;
  } catch (err) {
    console.warn('[ticket_title] ticket_ai_summary request failed:', err?.message || err);
  }
  return fallbackTicketTitle(text);
}
